module.exports = __webpack_public_path__ + "static/assets/72c3043b0fa788e4bba3cdad934339bb.svg";